module.exports = __webpack_public_path__ + "img/card-icon-visa.62a738ee.svg";